import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import {
  Table,
  Typography,
  Tag,
  Select,
  Row,
  Col,
  Button,
  Rate,
  message,
} from "antd";
import { StarOutlined, SearchOutlined, SyncOutlined } from "@ant-design/icons";
import AdvancedSearchForm from "../../../common/SearchForm";
import FeedbackDetailDrawerModal from "./components/feedbackDetailDrawerModal";
import styles from "../../../common/Layout.module.scss";
import LikeIcon from "../../../assets/like.svg";
import DislikeIcon from "../../../assets/dislike.svg";

const { Title, Link } = Typography;
const { Option } = Select;
function Feedback(props) {
  const atmedPaymentsRefresh = useSelector(
    (state) => state.vendorEquipmenReducer.allHomeFeedbackRefresh
  );

  const [descriptionModal, setDescriptionModal] = useState(false);
  const [currentColumn, setCurrentColumn] = useState([]);
  const [searchOption, setSearchOption] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const renderData = useCallback(
    (currentPage) => {
      props.getAtmedHealthFeedBack(undefined, 20, currentPage);
    },
    [props.getAtmedHealthFeedBack]
  );

  useEffect(() => {
    renderData(currentPage);
  }, [renderData, currentPage]);

  const handleRefresh = () => {
    props.getAtmedHealthFeedBack(undefined, 20, currentPage);
    if (atmedPaymentsRefresh && atmedPaymentsRefresh) {
      message.success(atmedPaymentsRefresh.message);
    }
  };

  const columns = [
    {
      title: "Session ID",
      key: "sid",
      dataIndex: "sid",
      render: (_, columnData) => (
        <Row className="name-details-row">
          <Col offset={1}>
            <div className="table-fc-email">Session ID: {columnData.sid}</div>
            <div className="table-fc-email">Booking ID: {columnData.bid}</div>
            <div className="table-fc-name">{columnData.service_name}</div>
            <div className="view-details">
              <Link
                onClick={() => {
                  setDescriptionModal(true);
                  setCurrentColumn(columnData);
                }}
              >
                VIEW DETAILS
              </Link>
            </div>
          </Col>
        </Row>
      ),
    },
    {
      title: "Vendor Name",
      key: "vendor_name",
      dataIndex: "vendor_name",
    },
    {
      title: "Patient Name",
      key: "patient_name",
      render: (_, columnData) => (
        <Row>
          <Col span={24}>{columnData.patient_name} </Col>
          <Col span={24} className="lightFont">
            {columnData.patient_phone}
          </Col>
          <Col span={24} className="lightFont">
            {columnData.patient_age} / {columnData.patient_gender}
          </Col>
        </Row>
      ),
    },
    {
      title: "Reviews",
      key: "review",
      render: (_, columnData) => (
        <div>
          <div className="content f-Size-13px">{`${columnData.review}`}</div>
          {columnData.rating >= 4 ? (
            <>
              {columnData.professionalism > 0 ? (
                <Tag color="success" className={styles.feedbackReviewStyle}>
                  <img
                    src={LikeIcon}
                    alt="Professionalism"
                    className="thumbs-up"
                  />
                  Professionalism
                </Tag>
              ) : (
                ""
              )}

              {columnData.punctuality > 0 ? (
                <Tag color="success" className={styles.feedbackReviewStyle}>
                  <img src={LikeIcon} alt="Punctuality" className="thumbs-up" />
                  Punctuality
                </Tag>
              ) : (
                ""
              )}

              {columnData.service > 0 ? (
                <Tag color="success" className={styles.feedbackReviewStyle}>
                  <img src={LikeIcon} alt="Service" className="thumbs-up" />
                  Service
                </Tag>
              ) : (
                ""
              )}
            </>
          ) : (
            <>
              {columnData.professionalism > 0 ? (
                <Tag color="error" className={styles.feedbackReviewStyle}>
                  <img src={DislikeIcon} alt="Professionalism" />
                  Professionalism
                </Tag>
              ) : (
                ""
              )}
              {columnData.punctuality > 0 ? (
                <Tag color="error" className={styles.feedbackReviewStyle}>
                  <img src={DislikeIcon} alt="Punctuality" />
                  Punctuality
                </Tag>
              ) : (
                ""
              )}
              {columnData.service > 0 ? (
                <Tag color="error" className={styles.feedbackReviewStyle}>
                  <img src={DislikeIcon} alt="Service" />
                  Service
                </Tag>
              ) : (
                ""
              )}
            </>
          )}
        </div>
      ),
    },
    {
      title: "Ratings",
      key: "rating",
      render: (_, columnData) => <Rate disabled value={columnData.rating} />,
    },
  ];
  const onSearch = (values) => {
    const newValues = JSON.parse(JSON.stringify(values));
    const queryString = Object.keys(newValues)
      .map((key) => `${key}=${newValues[key]}`)
      .join("&");
    props.getAtmedHealthFeedBack(queryString, 20, currentPage);
  };

  const toggleSearch = () => {
    setSearchOption(!searchOption);
  };

  return (
    <div>
      <FeedbackDetailDrawerModal
        data={currentColumn}
        visible={descriptionModal}
        onCancel={() => setDescriptionModal(false)}
      />
      <Row gutter={[0, 16]}>
        <Col className="gutter-row section-heading" span={19} offset={0}>
          <Title
            level={2}
            className="d-flex"
            style={{ justifyContent: "space-between", alignItems: "center" }}
          >
            Feedback / Ratings - Home Healthcare
          </Title>
        </Col>
        <Col className="gutter-row" span={3} offset={0}>
          <Button
            className={`${
              searchOption === true ? "search-open" : "search-close"
            } search-toggle-button`}
            onClick={() => toggleSearch()}
          >
            <SearchOutlined /> Search
          </Button>
        </Col>
        <Col className="gutter-row header-buttons" span={2} offset={0}>
          <Button
            shape="circle"
            icon={<SyncOutlined />}
            style={{ marginRight: 8 }}
            onClick={() => handleRefresh()}
          />
        </Col>
      </Row>
      {searchOption === true ? (
        <AdvancedSearchForm
          onSearch={onSearch}
          onClose={() => setSearchOption(false)}
          title="Home Healthcare"
          columnWidth={{
            xs: 24,
            md: 12,
            lg: 8,
          }}
          formItems={[
            {
              key: "q[home_session_sid_cont]",
              label: "Session ID",
            },
            {
              key: "q[home_vendor_name_cont]",
              label: "Vendor Name",
            },
            {
              key: "q[home_session_module_cont]",
              label: "Service Name",
            },
            {
              key: "q[patient_name_cont]",
              label: "Patient Name",
            },
            {
              key: "q[rating_eq]",
              label: "Ratings",
              Component: (
                <Select placeholder="Select Star Rating" size="large">
                  <Option value="5">
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                  </Option>
                  <Option value="4">
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                  </Option>
                  <Option value="3">
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                  </Option>
                  <Option value="2">
                    <StarOutlined />
                    <StarOutlined />
                  </Option>
                  <Option value="1">
                    <StarOutlined />
                  </Option>
                </Select>
              ),
            },
          ]}
        />
      ) : (
        ""
      )}
      <Table
        className="list_table"
        dataSource={props.allHomeFeedback ? props.allHomeFeedback.data : null}
        pagination={{
          pageSize: 20,
          total: props.allHomeFeedback?.total_count,
          showSizeChanger: false,
        }}
        columns={columns}
        scroll={{ x: 800 }}
        rowKey="id"
        onChange={(e) => {
          setCurrentPage(e.current);
        }}
      />
    </div>
  );
}

export default Feedback;
